// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MedicinaRadaCard_wrapper__ATwJK {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: white;
  height: 220px;
  width: 220px;
  border-radius: 16px;
  gap: 24px;
  margin-left: 25px;
  box-sizing: border-box;
}

.MedicinaRadaCard_wrapper__ATwJK:hover {
  border: #47a9f4 2px solid;
}

.MedicinaRadaCard_image__Q9wKR {
  width: 60px;
  height: 60px;
  background-color: transparent;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  overflow: hidden;
}
.MedicinaRadaCard_title__Km166 {
  font-family: "Open Sans";
  font-weight: 700;
  letter-spacing: 0px;
  text-align: center;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  font-size: 16px;
  max-width: 15ch;
  overflow: hidden;
  white-space: pre-wrap;
  text-overflow: ellipsis;
  color: #47a9f4;
}
@media screen and (max-width: 1250px) {
  .MedicinaRadaCard_wrapper__ATwJK {
    width: 200px;
    height: 200px;
  }
}

@media screen and (max-width: 1120px) {
  .MedicinaRadaCard_wrapper__ATwJK {
    width: 230px;
    height: 230px;
  }
}

@media screen and (max-width: 750px) {
  .MedicinaRadaCard_wrapper__ATwJK {
    width: 200px;
    height: 200px;
  }
}

@media screen and (max-width: 670px) {
  .MedicinaRadaCard_wrapper__ATwJK {
    width: 180px;
    height: 180px;
  }
}

@media screen and (max-width: 610px) {
  .MedicinaRadaCard_wrapper__ATwJK {
    width: 160px;
    height: 160px;
    gap: 20px;
  }
}

@media screen and (max-width: 560px) {
  .MedicinaRadaCard_wrapper__ATwJK {
    width: 150px;
    height: 150px;
  }
  .MedicinaRadaCard_image__Q9wKR {
    width: 50px;
    height: 50px;
  }
  .MedicinaRadaCard_title__Km166 {
    font-size: 15px;
  }
}

@media screen and (max-width: 500px) {
  .MedicinaRadaCard_wrapper__ATwJK {
    width: 140px;
    height: 140px;
    gap: 18px;
  }
  .MedicinaRadaCard_image__Q9wKR {
    width: 45px;
    height: 45px;
  }
  .MedicinaRadaCard_title__Km166 {
    font-size: 14px;
  }
}

@media screen and (max-width: 460px) {
  .MedicinaRadaCard_wrapper__ATwJK {
    width: 130px;
    height: 130px;
  }
  .MedicinaRadaCard_image__Q9wKR {
    width: 40px;
    height: 40px;
  }
  .MedicinaRadaCard_title__Km166 {
    font-size: 13px;
  }
}

@media screen and (max-width: 400px) {
  .MedicinaRadaCard_wrapper__ATwJK {
    width: 120px;
    height: 120px;
    gap: 10px;
  }
  .MedicinaRadaCard_image__Q9wKR {
    width: 37px;
    height: 37px;
  }
  .MedicinaRadaCard_title__Km166 {
    font-size: 12px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Components/MedicinaRada/MedicinaRadaCard/MedicinaRadaCard.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,sBAAsB;EACtB,2BAA2B;EAC3B,4BAA4B;EAC5B,gBAAgB;AAClB;AACA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,uBAAuB;EACvB,cAAc;AAChB;AACA;EACE;IACE,YAAY;IACZ,aAAa;EACf;AACF;;AAEA;EACE;IACE,YAAY;IACZ,aAAa;EACf;AACF;;AAEA;EACE;IACE,YAAY;IACZ,aAAa;EACf;AACF;;AAEA;EACE;IACE,YAAY;IACZ,aAAa;EACf;AACF;;AAEA;EACE;IACE,YAAY;IACZ,aAAa;IACb,SAAS;EACX;AACF;;AAEA;EACE;IACE,YAAY;IACZ,aAAa;EACf;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,YAAY;IACZ,aAAa;IACb,SAAS;EACX;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,YAAY;IACZ,aAAa;EACf;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,YAAY;IACZ,aAAa;IACb,SAAS;EACX;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,eAAe;EACjB;AACF","sourcesContent":[".wrapper {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  background-color: white;\n  height: 220px;\n  width: 220px;\n  border-radius: 16px;\n  gap: 24px;\n  margin-left: 25px;\n  box-sizing: border-box;\n}\n\n.wrapper:hover {\n  border: #47a9f4 2px solid;\n}\n\n.image {\n  width: 60px;\n  height: 60px;\n  background-color: transparent;\n  background-size: cover;\n  background-position: center;\n  background-repeat: no-repeat;\n  overflow: hidden;\n}\n.title {\n  font-family: \"Open Sans\";\n  font-weight: 700;\n  letter-spacing: 0px;\n  text-align: center;\n  display: -webkit-box;\n  -webkit-line-clamp: 3;\n  -webkit-box-orient: vertical;\n  font-size: 16px;\n  max-width: 15ch;\n  overflow: hidden;\n  white-space: pre-wrap;\n  text-overflow: ellipsis;\n  color: #47a9f4;\n}\n@media screen and (max-width: 1250px) {\n  .wrapper {\n    width: 200px;\n    height: 200px;\n  }\n}\n\n@media screen and (max-width: 1120px) {\n  .wrapper {\n    width: 230px;\n    height: 230px;\n  }\n}\n\n@media screen and (max-width: 750px) {\n  .wrapper {\n    width: 200px;\n    height: 200px;\n  }\n}\n\n@media screen and (max-width: 670px) {\n  .wrapper {\n    width: 180px;\n    height: 180px;\n  }\n}\n\n@media screen and (max-width: 610px) {\n  .wrapper {\n    width: 160px;\n    height: 160px;\n    gap: 20px;\n  }\n}\n\n@media screen and (max-width: 560px) {\n  .wrapper {\n    width: 150px;\n    height: 150px;\n  }\n  .image {\n    width: 50px;\n    height: 50px;\n  }\n  .title {\n    font-size: 15px;\n  }\n}\n\n@media screen and (max-width: 500px) {\n  .wrapper {\n    width: 140px;\n    height: 140px;\n    gap: 18px;\n  }\n  .image {\n    width: 45px;\n    height: 45px;\n  }\n  .title {\n    font-size: 14px;\n  }\n}\n\n@media screen and (max-width: 460px) {\n  .wrapper {\n    width: 130px;\n    height: 130px;\n  }\n  .image {\n    width: 40px;\n    height: 40px;\n  }\n  .title {\n    font-size: 13px;\n  }\n}\n\n@media screen and (max-width: 400px) {\n  .wrapper {\n    width: 120px;\n    height: 120px;\n    gap: 10px;\n  }\n  .image {\n    width: 37px;\n    height: 37px;\n  }\n  .title {\n    font-size: 12px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `MedicinaRadaCard_wrapper__ATwJK`,
	"image": `MedicinaRadaCard_image__Q9wKR`,
	"title": `MedicinaRadaCard_title__Km166`
};
export default ___CSS_LOADER_EXPORT___;
